import { render, staticRenderFns } from "./ChooseSubscription.vue?vue&type=template&id=260f603d&scoped=true&"
import script from "./ChooseSubscription.vue?vue&type=script&lang=ts&"
export * from "./ChooseSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseSubscription.vue?vue&type=style&index=0&id=260f603d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f603d",
  null
  
)

export default component.exports